export default __webpack_public_path__ + "static/media/close.0dc8d7d3.svg";